import { RequirementType } from "@wingspanhq/wingspan-api-sdk";

import {
  RequirementDefinitionSharedFileFormValues,
  RequirementDefinitionSignatureFormValues,
  RequirementDefinitionStandardBackgroundCheckFormValues
} from "../../../../types";
import { FlowCreateNewVersionSettingsData } from "../../types";

import { getBackgroundCheckSettings } from "./getBackgroundCheckSettings";
import { getInsuranceCoverageSettings } from "./getInsuranceCoverageSettings";
import { getSharedFileSettings } from "./getSharedFileSettings";
import { getSignatureSettings } from "./getSignatureSettings";

export const getRequirementSettingsItems = (
  requirementType: RequirementType,
  settings: FlowCreateNewVersionSettingsData
): string[] => {
  switch (requirementType) {
    case RequirementType.SIGNATURE:
      return getSignatureSettings(
        settings as Partial<
          Pick<RequirementDefinitionSignatureFormValues, "requiredSignatures">
        >
      );
    case RequirementType.DOCUMENT_UPLOAD:
      return getSharedFileSettings(
        settings as Partial<RequirementDefinitionSharedFileFormValues>
      );
    case RequirementType.BACKGROUND_CHECK:
      return getBackgroundCheckSettings(
        settings as Partial<RequirementDefinitionStandardBackgroundCheckFormValues>
      );
    case RequirementType.INSURANCE_COVERAGE:
      return getInsuranceCoverageSettings(settings);
    case RequirementType.BIOMETRIC_IDENTITY_VERIFICATION:
      return ["Document & biometric verification"];
    default:
      return ["—"];
  }
};
